import React from "react";
import { Collapse, Typography } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import InfoDetail from "./InfoDetail";
import { getLocalPhoneNumber } from "../../../util/helpers";
const { Link } = Typography;
const { Panel } = Collapse;

const Communications = (props) => {
  const { record } = props;
  const intl = useIntl();
  const EmailComp = () =>
    record?.contact_info?.email && (
      <Link
        href={`mailto:${record.contact_info.email}`}
        style={{ width: 190 }}
        ellipsis={true}
      >
        {record.contact_info.email}
      </Link>
    );
  return (
    <Collapse
      bordered={false}
      defaultActiveKey={["1"]}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined rotate={isActive ? 90 : 0} />
      )}
      className="custom-collapse-section"
    >
      <Panel
        header={intl.formatMessage({
          id: "app.leads.communications",
        })}
        key={"1"}
      >
        <div>
          {record?.contact_info?.mobile_number && (
            <InfoDetail
              title={intl.formatMessage({
                id: "app.leads.mobile_number",
              })}
              detail={getLocalPhoneNumber(record.contact_info.mobile_number)}
            />
          )}
          {record?.contact_info?.phone_number && (
            <InfoDetail
              title={intl.formatMessage({
                id: "app.leads.phone_number",
              })}
              detail={getLocalPhoneNumber(record.contact_info.phone_number)}
            />
          )}
          {record?.contact_info?.email && (
            <InfoDetail
              title={intl.formatMessage({
                id: "app.leads.email",
              })}
              detail={record.contact_info.email}
              component={<EmailComp />}
            />
          )}
        </div>
      </Panel>
    </Collapse>
  );
};
export default Communications;
